import './footer.scss';

import { CLink } from '@coreui/react';
import React from 'react';

import { useLocalize } from '../../hooks/useLocalize';

export const Footer: React.FC = () => {

  const { partnerStylingOverrides } = window.tz_globalConfigs;
  const { logoUrl } = window.tz_globalConfigs.styling;
  const { translate: t } = useLocalize();

  const shouldHideLogo = String(partnerStylingOverrides?.['whitelabel.footer.hideLogo']) === 'true';
  const shouldHideFooterDescription = String(partnerStylingOverrides?.['whitelabel.footer.hideFooterDescription']) === 'true';

  const checkMarks = ['confirmedImmediately', 'noSurprise', 'securePayment'];

  return (
    <>
      <div className="bottom-cards-wrapper">
        <div className="free-cancellation-card">
          <img className="free-cancellation-logo" src="/transferz/images/icon_free_cancellation.png" />
          <div className="free-cancellation-title">{t('freeCancellation_footer')}</div>
          <div className="free-cancellation-description">{t('bookToday')}</div>
        </div>
        <div className="easypayment-card">
          <h3 className="easypayment-title">{t('easyPayment')}</h3>
          <div className="easypayment-points">
            {checkMarks.map((checkMark, index) => (
              <div className="point" key={index}>
                <div className="check">
                  <span>✓</span>
                </div>
                <div className="point-description">{t(checkMark)}</div>
              </div>
            ))}
          </div>
          <div className="easypayment-logos">
            <img src="/transferz/images/visa.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/paypal.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/mastercard.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/maestro.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/apple-pay.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/google-pay.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/alipay.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/ideal.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/discovercard.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/dinersclub.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/amex.png" alt="available-payment-types" height="28" />
            <img src="/transferz/images/mada.png" alt="available-payment-types" height="28" />
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-container">
          {!shouldHideLogo && (
            <img src={partnerStylingOverrides?.['whitelabel.logoUrl'] || logoUrl} />
          )}
          {!shouldHideFooterDescription && (
            <div className="footer-description" >{t('transferzFooterDecription')}</div>
          )}
          <div className="trademark" >© 2025 Transferz</div>
          <div className="footer-terms" >
            <CLink
              style={{ color: partnerStylingOverrides?.['whitelabel.links.textColor'] }}
              href={`${window.tz_globalConfigs?.customPrefixUrl || ''}/terms-and-conditions`}
              target="_blank"
            >
              {t('register.termsAndConditions')}
            </CLink>
            <span> | </span>
            <CLink
              style={{ color: partnerStylingOverrides?.['whitelabel.links.textColor'] }}
              href={`${window.tz_globalConfigs?.customPrefixUrl || ''}/privacy-policy`}
              target="_blank"
            >
              {t('register.privacy')}
            </CLink>
          </div>
        </div>
      </div>
    </>
  );
};
